import Head from 'next/head'
import { useRouter } from 'next/router'
import sortUrlParams from 'src/seo/server/sortUrlParams'
import { TRACKING_PARAM_PREFIXES } from 'src/seo/constants/trackingParams'

const HOST = process.env.NEXT_PUBLIC_HOST
const onStage = process.env.NEXT_PUBLIC_STAGE === 'true'

export default function StaticSeo () {
  const router = useRouter()
  const underSubdomain = Boolean(router.query.subdomain)
  // ten sam adres co canonical (Seo.js): bez parametrów śledzących i adresu powrotu
  const path = sortUrlParams(router.asPath, ['filtry', 'powrot', ...TRACKING_PARAM_PREFIXES])

  return <Head>
    <meta property="fb:app_id" content="2561398784175766" />
    <meta property="og:site_name" content="samochody" />
    <meta name="twitter:site" content="@samochody.pl" />
    <meta name="twitter:creator" content="@samochody.pl" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=10, shrink-to-fit=no" />
    <meta key="robots" name="robots" content={onStage ? 'noindex, nofollow' : 'index, follow'} />
    <meta
				name="google-adsense-account"
				content="ca-pub-9600016495992077"
		/>

    { !underSubdomain && router.locales.map(locale =>
      <link
        key={locale}
        href={locale === 'pl-PL'
          ? `${HOST}${path}`
          : `${HOST}/${locale}${path}`}
        hrefLang={locale}
        rel="alternate" /> )}
  </Head>
}